import { defaults } from 'lodash';
import { calculateGroup, clientAllocate } from '@fiverr-private/experiments_package';
import { getContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_EXPERIMENT_FIELDS } from './constants';
import { clientExperiments } from '.';

export const calculateClientExperimentsGroups = (rollouts) => {
    const context = getContext();
    const calculatedGroups = {};

    Object.values(clientExperiments).forEach((experiment) => {
        const { experimentId, experimentType, numOfGroups } = defaults(experiment, DEFAULT_EXPERIMENT_FIELDS);

        if (experiment.getRolloutResult(rollouts) && experiment.shouldAllocate(context)) {
            calculatedGroups[experimentId] = calculateGroup({ experimentId, experimentType, numOfGroups, context });
        }
    });

    return calculatedGroups;
};

const allocatedGroups = {};

/**
 * Allocates to a client experiment, once per page: the search panel's components remount on every open, and each
 * allocating `clientAllocate` call sends an allocation request. Only allocated groups are kept: when `clientAllocate`
 * returns nothing (server, crawler, out of the rollout) it sent no request, so trying again is free and never caches a
 * value on the server.
 */
export const allocateToClientExperiment = (experiment, rollouts) => {
    const { experimentId, experimentType, numOfGroups } = defaults(experiment, DEFAULT_EXPERIMENT_FIELDS);

    if (!allocatedGroups[experimentId]) {
        allocatedGroups[experimentId] = clientAllocate({
            experimentId,
            experimentType,
            numOfGroups,
            rolloutResult: experiment.getRolloutResult(rollouts),
        });
    }

    return allocatedGroups[experimentId];
};
